/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
import { Catalog } from "./catalog.model";
import { ApplicationDefinition } from "../../routes/application-definition.model";

export class CatalogConverter {
  public static toApplicationDefinition(
    catalog: Catalog
  ): ApplicationDefinition {
    if (!catalog) {
      throw new Error("Null argument provided for catalog");
    }

    if (!catalog.name) {
      throw new Error("Null argument provided for catalog.name");
    }

    if (!catalog.route) {
      throw new Error("Null argument provided for catalog.route");
    }

    if (!catalog.mfeName) {
      throw new Error("Null argument provided for catalog.mfeName");
    }

    if (!catalog.mfeUrl) {
      throw new Error("Null argument provided for catalog.mfeUrl");
    }

    return {
      name: catalog.name,
      route: catalog.route,
      importUrl: catalog.mfeUrl,
      importName: catalog.mfeName,
      importType: catalog.mfeType,
    };
  }
}
